<svelte:head>
<!--   <script  src="https://code.jquery.com/jquery-3.5.1.min.js"
			  integrity="sha256-9/aliU8dGd2tb6OSsuzixeV4y/faTqgFtohetphbbj0="
			  crossorigin="anonymous"
			  defer>
  </script> -->
<!--   <script src="https://code.jquery.com/ui/1.12.1/jquery-ui.min.js"
			  integrity="sha256-VazP97ZCwtekAsvgPBSUwPFKdrwD3unUfSGVYrahUqU="
			  crossorigin="anonymous"
			  defer>
  </script> -->
	<script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/jquery/1.11.2/jquery.min.js"      on:load={jqueryLoaded}   defer></script>
	<script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.11.4/jquery-ui.min.js" on:load={jqueryuiLoaded} defer></script>

</svelte:head>

<script>

import { onMount, onDestroy } from 'svelte';

import { loggedIn                                                   } from '../_services/accountsession.js';

import Pivot			from './8iQsJsS5ujyXcjyR_Pivot.svelte';

// ----------------------------------------------------
// --   DECLARATIONS
// ----------------------------------------------------

   let query_pid = "";
	let seconds = 0;
   let query_data = [];
   
	var interval = 0;

  var display_pivot = false;



	var is_dataLoaded = false;
	onMount(async () => {
		if ($loggedIn) {

		}
	});

  var is_dependenciesLoaded = false;
  function dependenciesLoaded() {
  		if (   true 
  		       && is_jqueryLoaded  
  		       && is_jqueryuiLoaded  
  		       && is_dataLoaded 
  		   )
  	  {
			is_dependenciesLoaded = true;
	//		buildApplet();
  		}
  }

  var is_jqueryLoaded = false;
  function jqueryLoaded() {
		// The external Stripe javascript is ready.
		is_jqueryLoaded = true;
		dependenciesLoaded();
  }

  var is_jqueryuiLoaded = false;
  function jqueryuiLoaded() {
		// The external Stripe javascript is ready.
		is_jqueryuiLoaded = true;
		dependenciesLoaded();
  }


   var query_environment = 'dev';
   var query_id = '8iQsJsS5ujyXcjyR';
   var query_limit = '250000';

  
  var display_loadtimer = false;
  async function handleClickRun () {


		if ($loggedIn) {
			// fetch data


			// Call an authentication microservice to handle the authentication.
			var response = await fetch("https://analytics.artificiality.be/"+query_environment+"/drill/"+query_id+"/run?autoLimit="+query_limit+"",
			{
			    method: 'GET',
			    credentials: 'include',    // omit | include | same-origin
			    headers: {
			        'api_id': 'API_KEY',
			        'client_id': 'CLIENT_ID',
			        'client_secret': 'CLIENT_SECRET',
			        'client_session': CLIENT_SESSION,
			        'Content-Type': 'application/vnd.artificiality.drill.query-v1+json',
			        'Accept':       'application/vnd.artificiality.drill.querymetadata-v1+json',
			        'pragma':				'no-cache',
			        'cache-control':	'no-cache',			        
   			    },
//			    body: JSON.stringify({ }),
			})
			.then((response) => response.json())
			.then((response) => {
console.log(response);

						if ( response.response_meta.status === "success" /*=== true*/ ) {
console.log("if (response.response_meta.status === success)");
console.log("response.response_meta.process_pid_id = "+ response.response_meta.process_pid_id);

//	                  interval = setInterval(() => {seconds = seconds + 1;}, 1000); // @TODO -- not sure why interval 'is not set'
							query_pid = response.response_meta.process_pid_id;
							// keep at end
	                  display_loadtimer = true;

						} 

			  })
			  .catch((err) => {
console.log(err);
			})
			;
			
		}
			
  }

  async function handleClickStatus () {

			// Call an authentication microservice to handle the authentication.
			var response = await fetch("https://analytics.artificiality.be/"+query_environment+"/drill/"+query_id+"/"+query_pid+"/status",
			{
			    method: 'GET',
			    credentials: 'include',    // omit | include | same-origin
			    headers: {
			        'api_id': 'API_KEY',
			        'client_id': 'CLIENT_ID',
			        'client_secret': 'CLIENT_SECRET',
			        'client_session': CLIENT_SESSION,
			        'Content-Type':		'application/vnd.artificiality.drill.query-v1+json',
			        'Accept':				'application/vnd.artificiality.drill.querymetadata-v1+json',
			        'pragma':				'no-cache',
			        'cache-control':	'no-cache',			        
   			    },
//			    body: JSON.stringify({ }),
			})
			.then((response) => response.json())
			.then((response) => {
console.log(response);

						if ( response.response_meta.status === "success" /*=== true*/ ) {
console.log("if (response.response_meta.status === success)");
console.log("response.response_meta.process_pid_id = "+ response.response_meta.process_pid_id);

							// keep at end
//	                  display_loadtimer = true;

						} 
						else {
console.log("else (response.response_meta.status === "+response.response_meta.status+")");
console.log("response.response_meta.process_pid_id = "+ response.response_meta.process_pid_id);
							
						}
			  })
			  .catch((err) => {
console.log(err);
			})
			;
  }

  async function handleClickGetResult () {

			// Call an authentication microservice to handle the authentication.
			var response = await fetch("https://analytics.artificiality.be/"+query_environment+"/drill/"+query_id+"/"+query_pid+"/result",
			{
			    method: 'GET',
			    credentials: 'include',    // omit | include | same-origin
			    headers: {
			        'api_id': 'API_KEY',
			        'client_id': 'CLIENT_ID',
			        'client_secret': 'CLIENT_SECRET',
			        'client_session': CLIENT_SESSION,
			        'Content-Type': 'application/vnd.artificiality.drill.query-v1+json',
			        'Accept':       'application/vnd.artificiality.drill.queryresult-v1+json',
			        'pragma':				'no-cache',
			        'cache-control':	'no-cache',			        
   			    },
//			    body: JSON.stringify({ }),
			})
			.then((response) => response.json())
			.then((response) => {

						if (response.queryState === "COMPLETED") {

								query_data = [];
								query_data.push(response.columns);
								
								for (var i = 0; i < response.rows.length; i++) {
									 // convert dict to array
									 var row = [];
									 for (var j = 0; j < response.columns.length; j++) {
									 	row.push(  response.rows[i][ response.columns[j] ]  );
									 }
									// push row to dataset 
									query_data.push(  row ); 
								}			

								is_dataLoaded = true;
								dependenciesLoaded();

						} 

			  })
			  .catch((err) => {
console.log(err);
			})
			;
  }


  async function handleClickKill () {
        interval = null;
        seconds = null;
  }
  
// ----------------------------------------------------
// --   RUNTIME 
// ----------------------------------------------------

/*
				setTimeout(() => {
				    // do something nifty
  				}, 500 + Math.random() * 500);

*/

//$: run = is_dependenciesLoaded && fetchData() // <<-- should be hanlded in the onMount() ??

$: display_pivot = is_dependenciesLoaded;  

</script>



<style>

	.applet {
		width: inherit;
		height:550px;
	}

</style>


<div class="applet">

	<div>
		<div>PivotTable Drill 8iQsJsS5ujyXcjyR</div>
		<div>... some pivot table</div>
	</div>

	<div>
		<button on:click={handleClickRun}>Run</button>
		<button on:click={handleClickStatus}>Status</button>
		<button on:click={handleClickGetResult}>Get Result</button>
		<button on:click={handleClickKill}>Kill</button>
	</div>

	{#if $loggedIn}
	
		{#if display_pivot}
		<Pivot data={query_data} />
	
		{:else if display_loadtimer}
		<div>
			<p>It's been running for {seconds} seconds</p>
			<p>query_pid: {query_pid} </p>
		</div>
	
		{:else}
		<div>
			<p> Loading data and scripts and what not... </p>
		</div>
		{/if}


	{:else}
	<div>
		<p>Please log in...</p>
	</div>
	{/if}

</div>